import { render, staticRenderFns } from "./formDetall.vue?vue&type=template&id=ac62145e&scoped=true"
import script from "./formDetall.vue?vue&type=script&lang=js"
export * from "./formDetall.vue?vue&type=script&lang=js"
import style0 from "./formDetall.vue?vue&type=style&index=0&id=ac62145e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac62145e",
  null
  
)

export default component.exports